import { QueryClient } from '@tanstack/react-query';
import {
  GROUP_BY_PROJECT_KEY,
  GROUP_BY_RESOURCE_KEY,
  GROUP_BY_RESOURCE_TOTAL_KEY,
  PARTIAL_GROUP_BY_PROJECT_KEY,
  PARTIAL_GROUP_BY_RESOURCE_KEY,
} from '@legacy/apis/resourcePlannerAPI';

export const reloadRpTables = (qc: QueryClient) => {
  qc.invalidateQueries({ queryKey: [GROUP_BY_PROJECT_KEY] });
  qc.invalidateQueries({ queryKey: [GROUP_BY_RESOURCE_KEY] });
  qc.invalidateQueries({ queryKey: [GROUP_BY_RESOURCE_TOTAL_KEY] });
  qc.invalidateQueries({ queryKey: [PARTIAL_GROUP_BY_PROJECT_KEY] });
  qc.invalidateQueries({ queryKey: [PARTIAL_GROUP_BY_RESOURCE_KEY] });
};
